<template>
  <!-- 企業検診受付 -->
  <div id="KenshinRequestAccept">
    <div id="container">
      <kenshinNavi v-bind:pageid='"KenshinRequestAccept"'></kenshinNavi>
      <div class="kenshinLabelTitle lable">企業検診 受付（川越検査検診）</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" id="receiptNumber" v-model="searchConditions.receiptNumber"/></td>
            <th>デモ</th>
            <td><select id="demo" v-model="searchConditions.demo"><option></option><option value="false">含まない</option><option value="true">デモのみ</option></select></td>
            <th>検査種類</th>
            <td><select id="instrumentKind" v-model="searchConditions.inspectionKind"><option v-for="kind in inspectionKindList" :value="kind.value" :key="kind.value">{{ kind.label1 }}</option></select></td>
            <th>機種</th>
            <td><select id="model" v-model="searchConditions.model"><option v-for="device in kenshinDeviceList" :value="device.value" :key="device.value">{{ device.label1 }}</option></select></td>
          </tr>
          <tr>
            <th>依頼元種別</th>
            <td><select id="clientType" v-model="searchConditions.clientType"><option></option><option :value="role.role_corporation">企業</option><option :value="role.role_dealer">ディーラー</option><option :value="role.role_hospital">医療機関</option><option :value="role.role_accommodations">宿泊施設</option></select></td>
            <th>依頼元</th>
            <td><input type="text" id="client" v-model="searchConditions.client"/></td>
            <th>企業名</th>
            <td><input type="text" id="corporation" v-model="searchConditions.companyName"/></td>
          </tr>
          <tr>
            <th>申込日</th>
            <td colspan="3"><input type="date" id="applicationDateStart" v-model="searchConditions.applicationDateStart"/> ～ <input type="date" id="applicationDateEnd" v-model="searchConditions.applicationDateEnd"/></td>
            <th>出荷希望週</th>
            <td colspan="3"><input type="date" id="shippingDateStart" v-model="searchConditions.shippingDateStart"/> ～ <input type="date" id="shippingDateEnd" v-model="searchConditions.shippingDateEnd"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="hasResult">
        <b-table
            id="kenshinRequestAcceptTable"
            :data="data"
            :paginated="isPaginated"
            per-page="100"
            pagination-position="both"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
              <b-table-column field="receiptNumber" label="受付番号" width="100" sortable centered>
                <router-link :to="{name:'KenshinRequestAcceptDetail', query:{receiptNumber:encodeURIComponent(props.row.receiptNumber)}, params:{searchConditions:searchConditions}}">{{props.row.receiptNumber}}</router-link>
              </b-table-column>
              <b-table-column field="applicationDate" label="申込日" width="110" sortable centered>
                {{props.row.applicationDate }}
              </b-table-column>
              <b-table-column field="inspectionKind" label="検査種類" width="200" sortable>
                <div>{{props.row.inspectionKind | choiceFilter(inspectionKindList)}}<span v-if="props.row.demo" class="demo"/></div>
              </b-table-column>
              <b-table-column field="model" label="機種" width="180" sortable>
                {{props.row.model | choiceFilter(kenshinDeviceList)}}
              </b-table-column>
              <b-table-column field="shippingDate" label="出荷希望週" width="100" sortable>
                {{props.row.shippingDate}} ～
              </b-table-column>
              <b-table-column field="units" label="台数" width="60" sortable centered>
                {{props.row.units}}
              </b-table-column>
              <b-table-column field="client" label="依頼元" width="250" sortable>
                {{props.row.client}}<span v-if="props.row.proxyFlag" class="agent"/>
              </b-table-column>
              <b-table-column field="companyName" label="企業名" width="250" sortable>
                {{props.row.companyName}}
              </b-table-column>
              <b-table-column field="businessBiko" label="企業検診グループ備考"  width="600" sortable>
                {{props.row.businessBiko}}
              </b-table-column>
            </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/kenshin/KenshinNaviBar";
import {choicesType} from "@/components/mock/base/const.js";
import {role} from "@/components/mock/base/const.js";

export default {
  name: "KenshinRequestAccept",
  methods: {
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getKenshinKawagoeReceptionListPOST;
      var successCallBack = this.getKenshinKawagoeReceptionListPOSTSuccess;
      var errorCallBack = this.getKenshinKawagoeReceptionListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getKenshinKawagoeReceptionListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      if(!obj.clientType){
        delete obj.clientType
      }
      return client.apis.internalKenshin.getKenshinKawagoeReceptionListPOST({
        body:obj
      });
    },
    getKenshinKawagoeReceptionListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      if(this.data.length > 0){
        this.hasResult = true;
      }
    },
    getKenshinKawagoeReceptionListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var inspectionKindList = this.getChoiceList(choicesType.kenshinKind, false);
    var kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    inspectionKindList.unshift({})
    kenshinDeviceList.unshift({})
    return {
      role: role,
      inspectionKindList,
      kenshinDeviceList,
      searchConditions:{
        receiptNumber:"",
        demo:"",
        inspectionKind:"",
        model:"",
        clientType:"",
        client:"",
        companyName:"",
        applicationDateStart:"",
        applicationDateEnd:"",
        shippingDateStart:"",
        shippingDateEnd:""
      },
      takeOverSearchParams,
      data : [],
      isPaginated : true,
      hasResult:false
    };
  },
  async mounted() {
    // 選択肢マスタ取得
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {
    choiceFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    kenshinNavi: naviBar
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width :100px;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinRequestAccept.vue